#vx-sorting {
  display: inline-block;
  width: 100%;
}

.vx-sorting__label {
  text-align: var(--vx-sorting-label-text-align, center);
  margin: 2px 0;
  position: relative;
  display: block;
  width: 100%;
  height: 40px;
}

.vx-sorting__label-text {
  font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: var(--vx-sorting-label-text-color, #000);
  font-weight: var(--vx-sorting-label-text-font-weight, 600);
  font-size: 1.1429em;
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  appearance: none;
  background: transparent;
  border: none;
  border-radius: 8px;
}
.vx-sorting__label-text::after {
  content: " ";
  display: inline-block;
  width: 10px;
  height: 10px;
  transition: 0.3s ease all;
  transform: rotate(45deg) translateX(2px) translateY(-6px);
  border-color: black;
  border-width: 8px;
  border-right: solid;
  border-bottom: solid;
}

button:focus-visible,
button:hover {
  outline: none;
  background: var(--ci-primary400);
  color: #fff;
}

.vx-sorting__select {
  text-align: var(--vx-sorting-select-text-align, center);
  border: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  background-color: white;
  appearance: none;
}

.vx-sorting__select--desktop {
  display: none;
  pointer-events: none;
}

@media only screen and (min-width: 768px) {
  .vx-sorting__label {
    margin: 0;
    line-height: 1;
  }
  .vx-sorting__label-text {
    text-align: right;
    padding-right: 20px;
    cursor: pointer;
    pointer-events: all;
    line-height: 1;
  }
  .vx-sorting__label-text::after {
    position: relative;
    left: 2px;
  }
  .vx-sorting__label--open .vx-sorting__label-text::after {
    transform: rotate(-135deg) translateX(-6px) translateY(2px);
  }
  .vx-sorting__select--mobile {
    display: none;
    pointer-events: none;
  }
  .vx-sorting__select--desktop {
    display: block;
    visibility: hidden;
    opacity: 0;
    pointer-events: all;
    cursor: pointer;
    background-color: white;
    position: absolute;
    top: 30px;
    right: 0;
    z-index: 5;
    box-shadow: 0 5px 15px var(--ci-neutral300);
    border: 1px solid var(--neutral-neutral-300, #ECECEC);
    border-radius: 8px;
    overflow: hidden;
    transition: top 0.3s ease, opacity 0.3s ease, visibility 0.3s 0s linear;
    width: 100%;
  }
  .vx-sorting__select--desktop ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  .vx-sorting__select--desktop li {
    border-bottom: 1px solid var(--neutral-neutral-300, #ECECEC);
  }
  .vx-sorting__select--desktop li:last-child {
    border-bottom: none;
  }
  .vx-sorting__select--desktop .vx-sorting__option {
    font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
    padding: 13px 20px;
    color: var(--vx-sorting-label-text-color, #000);
    display: block;
    text-decoration: none;
  }
  .vx-sorting__select--desktop .vx-sorting__option:focus, .vx-sorting__select--desktop .vx-sorting__option:hover {
    color: var(--vx-sorting-option-highlight-text-color, #fff);
    background-color: var(--vx-sorting-option-highlight-background-color, #00869B);
  }
  .vx-sorting__select--desktop .vx-sorting__selected-option {
    color: var(--vx-sorting-option-selected-highlight-text-color, #fff);
    background-color: var(--vx-sorting-option-selected-highlight-background-color, #006b7e);
  }
  .vx-sorting__select--desktop .vx-sorting__loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.5);
    z-index: 10;
    display: none;
    justify-content: center;
    align-items: center;
  }
  .vx-sorting__select--desktop.vx-sorting__loading-visible .vx-sorting__loading-overlay {
    display: flex;
  }
  .vx-sorting__label--open .vx-sorting__select--desktop {
    visibility: visible;
    opacity: 1;
    top: 40px;
    transition: top 0.3s ease, opacity 0.3s ease, visibility 0s linear;
  }
}